import { User } from "../../../types/user/user";
import { UserState } from "../../type/user-state";

interface Action {
  type: string;
  payload: {
    selectedUser: User;
  };
}

export const setSelectedUserDispatch = (state: UserState, action: Action) => {
  const { selectedUser } = action.payload;
  state.selectedUser = selectedUser;
};
